exports = module.exports = require("../../../node_modules/react-scripts/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer {\n  position: relative;\n  padding: 1rem 2.2rem;\n  color: #000;\n  text-align: left;\n  height: 5vh; }\n  footer p, footer a {\n    display: inline-block;\n    font-size: 1.2rem; }\n  footer a {\n    margin: 0 0 0 1rem;\n    padding: 0;\n    text-align: right; }\n    footer a svg {\n      margin-right: .5rem; }\n    footer a.top {\n      float: right; }\n", ""]);

// exports
